<template>
    <TotemSearch
        v-model="searchPhrase"
        v-on:clearSearch="onClearSearch"
        :placeholder="placeholder"
    />
</template>

<script>
    import _ from 'lodash'
    import filteringHelper from 'components/user/organizationreport/filters/helpers/filteringHelper'

    export default {
        name: 'reporting-search-phrase',
        mixins: [ filteringHelper ],
        inject: ['tab'],
        props: {
            placeholder: {
                type: String
            }
        },
        data () {
            return {
                searchPhrase: this.searchQuery
            }
        },
        methods: {
            onClearSearch () {
                this.$store.dispatch(this.getSetQueryRoute, null)
                this.searchPhrase = null
            },
            setQuery (query) {
                this.$store.dispatch(this.getSetQueryRoute, query)
            },
            debouncedSetQuery: _.debounce(function (query) {
                this.setQuery(query)
            }, 500)

        },
        watch: {
            searchPhrase (searchPhrase) {
                this.debouncedSetQuery(searchPhrase)
            },
            searchQuery (searchQuery) {
                this.searchPhrase = searchQuery
            }
        },
        mounted () {
            this.searchPhrase = this.searchQuery
        }
    }
</script>
